import { useSiteContent } from '@/context/SiteContentContext';
import ImageUploadField from './ImageUploadField';

export default function AdminAboutTab() {
  const { content, updateContent } = useSiteContent();
  const a = content.about;

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-bold text-gray-900 border-b border-gray-100 pb-3">About Section</h3>

      <ImageUploadField
        label="About Image"
        value={a.image}
        onChange={(v) => updateContent('about.image', v)}
      />

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Heading Line 1</label>
          <input
            type="text"
            value={a.heading1}
            onChange={(e) => updateContent('about.heading1', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Heading Line 2</label>
          <input
            type="text"
            value={a.heading2}
            onChange={(e) => updateContent('about.heading2', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Paragraph 1</label>
        <textarea
          value={a.para1}
          rows={3}
          onChange={(e) => updateContent('about.para1', e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none"
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Paragraph 2</label>
        <textarea
          value={a.para2}
          rows={3}
          onChange={(e) => updateContent('about.para2', e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none"
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Vision</label>
        <textarea
          value={a.vision}
          rows={2}
          onChange={(e) => updateContent('about.vision', e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none"
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Mission</label>
        <textarea
          value={a.mission}
          rows={2}
          onChange={(e) => updateContent('about.mission', e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none"
        />
      </div>
    </div>
  );
}
